<template>
    <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="newStageModalLabel">Add New Stage</h5>
        <button type="button" v-on:click="clear" class="btn-close" data-bs-dismiss="modal" ></button>
      </div>
      <div class="modal-body">
        <div class="mt-3">
        <label for="StageName" class="form-label">Stage Name*</label>
    <input type="text" class="form-control pl-3" v-model="name" id="StageName" aria-describedby="emailHelp">
  </div>
  <div class="mt-3">
        <label for="Details" class="form-label">Stage Details</label>
        <textarea class="form-control pl-3" v-model="clubDetails" placeholder="Leave a comment here" id="floatingTextarea"></textarea>
  </div>
  <div class="mt-3">
        <label for="Details" class="form-label">Performance Length<button class="tooltip-btn " type="button" v-on:click="lengthExplanation()" >
      <span class="question-mark">?</span>
    </button></label>
      <input type="text" class="form-control pl-3" v-model="act_length" id="StageName" aria-describedby="emailHelp">
  </div>
      </div>
      <div class="modal-footer">
        <button type="button" ref="close" v-show="false"  class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" v-on:click="clear" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" v-on:click="saveItem()"  class="btn btn-primary">Save changes</button>
      </div>
    </div>
  </div>
</template>

<script>
//import newMenuItem from "../components/modals/newMenuItem.vue"
import stageService from "../../api/stage.js"
import swal from 'sweetalert';

export default {
  name: 'AddNewStage',
  props:["stage","venueId"],
  data() {
    return {
        name:"",
        clubDetails:"",
        update:false,
        act_length:4
    };
  },
  methods:{
    lengthExplanation(){
        swal("Act Length", "Performer profiles will appear in the app for a set duration. The default is 4 hours, which matches the standard length of most shows.");    
    },
    saveItem(){
      if(this.name.length===0){
        swal("Name is required here", {
            icon: "error", // You can customize the icon (info, success, error, warning, question)
          })
      }
      else if (isNaN(Number(this.act_length))) {
        swal("Performance length must be a number", {
            icon: "error", // You can customize the icon (info, success, error, warning, question)
          })
      }
      else{
        var stage = {
          name:this.name,
          venue_ID: this.$props.venueId,
          description: this.clubDetails,
          act_length: this.act_length,
          is_disabled:false
        }
        if(!this.update){
          stageService.saveNewStage(stage).then(data=>{
          this.$emit("addNewStage",data)
          this.clear()
           this.$refs.close.click();
        })
        }
        else{
          stageService.updateStageByID(this.$props.stage._id,stage).then(data=>{
          this.$emit("updateStage",data)
          this.clear()
           this.$refs.close.click();
        })
        }
      }        
    },
    clear(){
      this.name = ""
      this.clubDetails = ""
      this.act_length= 4
      this.update = false
      this.$emit("refreshEdit")
      this.$refs.close.click();
    }
  },
  watch:{
        stage(){
         if(this.$props.stage!=""){
            this.name=this.$props.stage.name
            this.clubDetails= this.$props.stage.description
            this.act_length = this.$props.stage.act_length
            this.update=true;
        }
        }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
